<template>
  <div class="setting">
    <CDNbreadcrumbs :items="items" />
    <!--  -->
    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane :label="$t('product.flow')" name="first">
        <staticliuliangProdct1
          v-if="activeName === 'first'"
          mytype="flows"
          :current_host="current_host"
         />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.statuscode')" name="second">
        <staticliuliangProdct1
          v-if="activeName === 'second'"
          mytype="codes"
          :current_host="current_host"
         />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.hitrate')" name="third">
       <staticliuliangProdct1
          v-if="activeName === 'third'"
          mytype="hits"
          :current_host="current_host"
         />
    </el-tab-pane>
    <el-tab-pane :label="$t('product.defense')" name="four">
         <staticliuliangProdct1
          v-if="activeName === 'four'"
          mytype="wafs"
          :current_host="current_host"
         />
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import staticliuliangProdct1 from '@/views/dev/staticliuliangProdct1.vue';
export default {
  props: {
    type: String,
    current_host: String,
  },
  components: {
    staticliuliangProdct1,
  },
  data() {
    return {
      activeName: 'first',
    };
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('product.productlist'),
          click: () => {
            this.$emit('closePage');
          },
        },
        {
          label: this.$t('product.Statistics'),
        },
      ];
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.setting {
    background-color: white;
    padding: 24px;
}
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
